var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#178477"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 27.7505C18.5899 27.7505 18.2499 27.4105 18.2499 27.0005V22.8105L17.5299 23.5305C17.2399 23.8205 16.7599 23.8205 16.4699 23.5305C16.1799 23.2405 16.1799 22.7605 16.4699 22.4705L18.4699 20.4705C18.6799 20.2605 19.0099 20.1905 19.2899 20.3105C19.5699 20.4205 19.7499 20.7005 19.7499 21.0005V27.0005C19.7499 27.4105 19.4099 27.7505 18.9999 27.7505Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 23.7495C20.8099 23.7495 20.6199 23.6795 20.4699 23.5295L18.4699 21.5295C18.1799 21.2395 18.1799 20.7595 18.4699 20.4695C18.7599 20.1795 19.2399 20.1795 19.5299 20.4695L21.5299 22.4695C21.8199 22.7595 21.8199 23.2395 21.5299 23.5295C21.3799 23.6795 21.1899 23.7495 20.9999 23.7495Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 32.75H19C13.57 32.75 11.25 30.43 11.25 25V19C11.25 13.57 13.57 11.25 19 11.25H24C24.41 11.25 24.75 11.59 24.75 12C24.75 12.41 24.41 12.75 24 12.75H19C14.39 12.75 12.75 14.39 12.75 19V25C12.75 29.61 14.39 31.25 19 31.25H25C29.61 31.25 31.25 29.61 31.25 25V20C31.25 19.59 31.59 19.25 32 19.25C32.41 19.25 32.75 19.59 32.75 20V25C32.75 30.43 30.43 32.75 25 32.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20.7505H28C24.58 20.7505 23.25 19.4205 23.25 16.0005V12.0005C23.25 11.7005 23.43 11.4205 23.71 11.3105C23.99 11.1905 24.31 11.2605 24.53 11.4705L32.53 19.4705C32.74 19.6805 32.81 20.0105 32.69 20.2905C32.57 20.5705 32.3 20.7505 32 20.7505ZM24.75 13.8105V16.0005C24.75 18.5805 25.42 19.2505 28 19.2505H30.19L24.75 13.8105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.1ebbc7cb1afb9a9616b8e63f91fd45c5.svg";
export { ForwardRef as ReactComponent };